export class IndicadoresIndicacoes {
    cadastrados: number;
    perdidos: number;
    emAtividade: number;
    aExpirar: number;
}
